<template>
  <div class="flex items-start gap-3 rounded-[var(--radius-md)] p-4 text-sm leading-relaxed" :class="tones[tone]">
    <span class="mt-0.5 shrink-0 text-base">{{ glyphs[tone] }}</span>
    <div class="min-w-0">
      <span v-if="title" class="font-semibold">{{ title }}</span>
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{ tone?: 'info' | 'warning' | 'success' | 'danger'; title?: string }>()

const tones: Record<string, string> = {
  info: 'bg-[var(--info-bg)] text-[var(--info)]',
  warning: 'bg-[var(--warning-bg)] text-[var(--warning)]',
  success: 'bg-[var(--success-bg)] text-[var(--success)]',
  danger: 'bg-[var(--danger-bg)] text-[var(--danger)]',
}

const glyphs: Record<string, string> = {
  info: 'ⓘ',
  warning: '⚠️',
  success: '✓',
  danger: '✕',
}
</script>
